const PRODUCT_PREMIUM_TYPE_ENUM = {
  COMING_SOON: 'COMING_SOON',
  SOLD_OUT: 'SOLD_OUT',
  FLASH_SALE: 'FLASH_SALE',
  LOW_STOCK: 'LOW_STOCK',
  BACK_IN_STOCK: 'BACK_IN_STOCK',
}

export default PRODUCT_PREMIUM_TYPE_ENUM
